// import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
// import {
//   Box,
//   Button,
//   Container,
//   Grid,
//   InputLabel,
//   TextField,
//   Typography,
//   useTheme,
// } from "@mui/material";
// import CloudUploadIcon from "@mui/icons-material/CloudUpload";
// import CryptoJS from "crypto-js";
// import Loader from "../loader/Loader";

// const AppQualification = forwardRef(({ initialData = {} }, ref) => {
//   const theme = useTheme();
//   const isDarkMode = theme.palette.mode === "dark";

//   const [employeeQualification, setEmployeeQualification] = useState({
//     employee_id: initialData.employee_id || "",
//     master_degree_certificate: null,
//     bachelor_degree_certificate: null,
//     hsc_certificate: null,
//     ssc_certificate: null,
//     other_certificates: null,
//   });

//   const [loading, setLoading] = useState(false);
//   const [successMessage, setSuccessMessage] = useState("");
//   const [errorMessage, setErrorMessage] = useState("");

//   useEffect(() => {
//     if (initialData) {
//       setEmployeeQualification((prev) => ({
//         ...prev,
//         ...initialData,
//         employee_id: initialData.employee_id || prev.employee_id,
//       }));
//     }
//   }, [initialData]);

//   const handleFileChange = (e) => {
//     const { name, files } = e.target;
//     setEmployeeQualification((prev) => ({
//       ...prev,
//       [name]: files[0],
//     }));
//   };

//   const handleSubmit = async () => {
//     setSuccessMessage("");
//     setErrorMessage("");
//     setLoading(true);

//     try {
//       const encryptedapikey = sessionStorage.getItem("encrypted_data");
//       const base64Key = sessionStorage.getItem("base64_Key");
//       let decryptedjwt = "";

//       if (base64Key && encryptedapikey) {
//         const key = CryptoJS.enc.Base64.parse(base64Key);
//         const dataBytes = CryptoJS.enc.Base64.parse(encryptedapikey);
//         const iv = CryptoJS.lib.WordArray.create(dataBytes.words.slice(0, 4));
//         const ciphertext = CryptoJS.lib.WordArray.create(dataBytes.words.slice(4));
//         const decryptedBytes = CryptoJS.AES.decrypt({ ciphertext }, key, { iv });
//         decryptedjwt = CryptoJS.enc.Utf8.stringify(decryptedBytes);
//       }

//       const formData = new FormData();
//       formData.append("employee_id", employeeQualification.employee_id);

//       Object.entries(employeeQualification).forEach(([key, value]) => {
//         if (key !== "employee_id" && value) {
//           formData.append(key, value);
//         }
//       });
//       const accessToken = JSON.parse(localStorage.getItem('emsUser'))?.user?.stsTokenManager?.accessToken;
//       const response = await fetch(`${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-qualification`, {
//         method: "POST",
//         headers: { "X-API-Key": decryptedjwt },
//         body: formData,
//         'Authorization': `Bearer ${accessToken}`
//       });

//       const data = await response.json();
//       if (response.ok) {
//         //setSuccessMessage(data.message);
//         return employeeQualification;
//       } else {
//         setErrorMessage(data.message || "Failed to upload qualifications.");
//         return false;
//       }
//     } catch (error) {
//       console.error("Upload Error:", error);
//       setErrorMessage("An error occurred while uploading qualifications.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   useImperativeHandle(ref, () => ({
//     handleSubmit,
//   }));

//   return (
//     <Container maxWidth="md">
//       {loading && (
//         <Box
//           sx={{
//             position: "fixed",
//             top: 0,
//             left: 0,
//             width: "100vw",
//             height: "100vh",
//             background: "rgba(0, 0, 0, 0.5)",
//             display: "flex",
//             justifyContent: "center",
//             alignItems: "center",
//             zIndex: 1000,
//           }}
//         >
//           <Loader />
//         </Box>
//       )}

//       <Box
//         sx={{
//           backgroundColor: isDarkMode ? "background.default" : "white",
//           padding: 4,
//           mt: 5,
//         }}
//       >
//         <Typography
//           variant="h5"
//           textAlign="center"
//           sx={{ mb: 2, fontWeight: "bold", color: isDarkMode ? "text.primary" : "black" }}
//         >
//           Add Qualification Documents
//         </Typography>

//         <Grid container spacing={2} direction="column">
//           {[
//             "master_degree_certificate",
//             "bachelor_degree_certificate",
//             "hsc_certificate",
//             "ssc_certificate",
//             "other_certificates",
//           ].map((field) => (
//             <Grid item xs={12} key={field}>
//               <InputLabel sx={{ fontWeight: "bold", color: isDarkMode ? "text.primary" : "black" }}>
//                 {field.replace(/_/g, " ").toUpperCase()}
//               </InputLabel>

//               <Button
//                 component="label"
//                 variant="contained"
//                 startIcon={<CloudUploadIcon />}
//                 fullWidth
//                 sx={{
//                   textTransform: "none",
//                   backgroundColor: isDarkMode ? "#4caf50" : "#1976d2",
//                   color: "white",
//                   "&:hover": {
//                     backgroundColor: isDarkMode ? "#388e3c" : "#1565c0",
//                   },
//                 }}
//               >
//                 Upload File
//                 <input type="file" name={field} hidden onChange={handleFileChange} />
//               </Button>

//               {employeeQualification[field] && (
//                 <Typography variant="body2" sx={{ color: "green", mt: 1 }}>
//                   Selected: {employeeQualification[field].name}
//                 </Typography>
//               )}
//             </Grid>
//           ))}
//         </Grid>

//         {successMessage && (
//           <Typography color="green" align="center" mt={2}>
//             {successMessage}
//           </Typography>
//         )}
//         {errorMessage && (
//           <Typography color="red" align="center" mt={2}>
//             {errorMessage}
//           </Typography>
//         )}
//       </Box>
//     </Container>
//   );
// });

// export default AppQualification;

import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
} from "react";
import { useParams } from "react-router-dom";
import {
  Box,
  Button,
  Container,
  Grid,
  InputLabel,
  TextField,
  Typography,
  useTheme,
  IconButton,
} from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { Delete } from "@mui/icons-material";
import { tokens } from "../../../../../theme";
import CryptoJS from "crypto-js";

const AppQualification = forwardRef((props, ref) => {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === "dark";
  const params = useParams();
  const employee_id = params.employee_id || params.employeeId || null;
   const colors = tokens(theme.palette.mode);
  const [addData, setAddData] = useState({
    employee_id: employee_id || "",
    master_degree_certificate: null,
    bachelor_degree_certificate: null,
    hsc_certificate: null,
    ssc_certificate: null,
    other_certificates: null,
  });

  const [editData, setEditData] = useState(null); 
  const [selectedFiles, setSelectedFiles] = useState({});
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    if (!employee_id) return; 

    setLoading(true);
    fetch(
      `${process.env.REACT_APP_BACKEND_URL_HRM}/get-qualification/${employee_id}`
    )
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`Failed to fetch: ${res.status}`);
        }
        const json = await res.json();
        if (json.data) {
          setEditData(json.data);
        } else {
          setErrorMessage("Qualification data not found.");
        }
      })
      .catch((err) => {
        setErrorMessage(err.message || "Error fetching qualification data.");
      })
      .finally(() => {
        setLoading(false);
      });
  }, [employee_id]);


  const handleAddFileChange = (e) => {
    const { name, files } = e.target;
    setAddData((prev) => ({
      ...prev,
      [name]: files[0],
    }));
  };

    const handleSave = async (corporateEmail) => {
      setLoading(true);

      try {
      
        const formDataToSend = new FormData();
        formDataToSend.append("corporate_email_id", corporateEmail);

        // const allCertificates = [
        //   addData.master_degree_certificate,
        //   addData.bachelor_degree_certificate,
        //   addData.hsc_certificate,
        //   addData.ssc_certificate,
        //   addData.other_certificates,
        // ].filter(Boolean);

        // allCertificates.forEach((file) => {
        //   formDataToSend.append("uploaded_certificates", file); 
        // });
        const fields = [
            "master_degree_certificate",
            "bachelor_degree_certificate",
            "hsc_certificate",
            "ssc_certificate",
            "other_certificates"
          ];

          fields.forEach((field) => {
            const file = addData[field];
            if (file instanceof File) {  // check if it's a file
              formDataToSend.append(field, file);
            }
          });

        const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user?.stsTokenManager?.accessToken;

        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/add-employee-qualification`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
            body: formDataToSend,
          }
        );

        const data = await response.json();
        if (response.ok && data.status === "success") {
          setSuccessMessage(data.message || "Qualification added successfully.");
          return addData;
        } else {
          setErrorMessage(data.message || "Failed to upload qualifications.");
          return false;
        }
      } catch (error) {
        setErrorMessage("An error occurred while uploading qualifications.");
        return false;
      } finally {
        setLoading(false);
      }
    };

    const handleEditFileChange = (e) => {
      const { name, files } = e.target;
      if (files[0]) {
        setSelectedFiles((prev) => ({ ...prev, [name]: files[0] }));
      }
    };

    const handleRemoveFile = async (name) => {
      if (!editData?.uploaded_certificates?.[name]) return;

      setLoading(true);
      try {
        const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user?.stsTokenManager?.accessToken;
        const response = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/delete-qualification-file/${employee_id}/${name}`,
          {
            method: "DELETE",
            headers: { Authorization: `Bearer ${accessToken}` },
          }
        );

        if (!response.ok) throw new Error("Failed to delete file.");

        // Update local state after deletion
        const updatedCertificates = { ...editData.uploaded_certificates };
        delete updatedCertificates[name];

        setEditData((prev) => ({
          ...prev,
          uploaded_certificates: updatedCertificates,
        }));

        setSuccessMessage("File deleted successfully.");
      } catch (error) {
        console.error("Error deleting file:", error);
        setErrorMessage("Failed to delete file.");
      } finally {
        setLoading(false);
      }
    };

    const handleUpdate = async () => {
      setLoading(true);

      try {
        const accessToken = JSON.parse(localStorage.getItem("emsUser"))?.user?.stsTokenManager?.accessToken;
        let updatedCertificates = { ...editData.uploaded_certificates };
         const formData = new FormData();

        for (const key in selectedFiles) {
          formData.append(key, selectedFiles[key]);
        }

        formData.append(
          "uploaded_certificates",
          JSON.stringify(updatedCertificates)
        );

        const updateResponse = await fetch(
          `${process.env.REACT_APP_BACKEND_URL_HRM}/update-employee-qualification/${employee_id}`,
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
             body: formData,
          }
        );

        const updateData = await updateResponse.json();
        if (updateData.updated === false || updateData.message === "No changes detected.") {
          setSuccessMessage("No changes detected. Qualification remains the same.");
        } else {
          setSuccessMessage("Qualification updated successfully.");
        }

        setEditData((prev) => ({
          ...prev,
          uploaded_certificates: updatedCertificates,
        }));

        setSelectedFiles({});

        return true;

      } catch (error) {
        console.error("Update failed:", error);
        setErrorMessage(error.message || "Failed to update qualification.");
        return false;
      } finally {
        setLoading(false);
      }
    };


  useImperativeHandle(ref, () => ({
    save: async (corporateEmail) => {
      return await handleSave(corporateEmail);
    },

    update: async () => {
      const result = await handleUpdate(); 
      return result; 
    }
  }));

  const renderAddMode = () => (
    <Container maxWidth="md">
      {loading && (
        <Box
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0, 0, 0, 0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <Typography variant="h6" color="white">
            Loading...
          </Typography>
        </Box>
      )}

      <Box
        sx={{
          backgroundColor: isDarkMode ? "background.default" : "white",
          padding: 4,
          mt: 5,
        }}
      >
        <Typography
          variant="h5"
          textAlign="center"
          sx={{
            mb: 2,
            fontWeight: "bold",
            color: isDarkMode ? "text.primary" : "black",
          }}
        >
          Add Qualification Documents
        </Typography>

        <Grid container spacing={2} direction="column">
          {[
            "master_degree_certificate",
            "bachelor_degree_certificate",
            "hsc_certificate",
            "ssc_certificate",
            "other_certificates",
          ].map((field) => (
            <Grid item xs={12} key={field}>
              <InputLabel
                sx={{
                  fontWeight: "bold",
                  color: isDarkMode ? "text.primary" : "black",
                }}
              >
                {field.replace(/_/g, " ").toUpperCase()}
              </InputLabel>

              <Button
                component="label"
                variant="contained"
                startIcon={<CloudUploadIcon />}
                fullWidth
                sx={{
                  textTransform: "none",
                  backgroundColor: isDarkMode ? "#4caf50" : "#1976d2",
                  color: "white",
                  "&:hover": {
                    backgroundColor: isDarkMode ? "#388e3c" : "#1565c0",
                  },
                }}
              >
                Upload File
                <input
                  type="file"
                  name={field}
                  hidden
                  onChange={handleAddFileChange}
                />
              </Button>

              {addData[field] && (
                <Typography variant="body2" sx={{ color: "green", mt: 1 }}>
                  Selected: {addData[field].name}
                </Typography>
              )}
            </Grid>
          ))}
        </Grid>

        {successMessage && (
          <Typography color="green" align="center" mt={2}>
            {successMessage}
          </Typography>
        )}
        {errorMessage && (
          <Typography color="red" align="center" mt={2}>
            {errorMessage}
          </Typography>
        )}
      </Box>
    </Container>
  );

  const renderEditMode = () => (
    <Container maxWidth="md" sx={{ mt: 5, p: 4, textAlign: "center" }}>
      <Box elevation={3} sx={{ textAlign: "left" }}>
        {[
          "master_degree_certificate",
          "bachelor_degree_certificate",
          "hsc_certificate",
          "ssc_certificate",
          "other_certificates",
        ].map((certName) => (
          <Box key={certName} my={3}>
            <Typography variant="body1" fontWeight="bold">
              {certName.replace(/_/g, " ").toUpperCase()}:
            </Typography>
            {editData?.uploaded_certificates?.[certName] || selectedFiles[certName] ? (
              editData?.uploaded_certificates?.[certName] && (
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  gap={1}
                  mt={1}
                >
                  <Typography variant="body2" color="green">
                    Existing:{" "}
                    <a
                      href={editData.uploaded_certificates[certName]}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: "blue" }}
                    >
                      View Document
                    </a>
                  </Typography>
                  <IconButton
                    color="error"
                    onClick={() => handleRemoveFile(certName)}
                  >
                    <Delete />
                  </IconButton>
                </Box>
              )
            ) : (
              <Typography variant="body2" color="error">
                No document found! Please upload a new file.
              </Typography>
            )}

            <Button
              variant="outlined"
              component="label"
              fullWidth
              sx={{ mt: 1 }}
              style={{
                padding: "10px",
                color: "#C0C0C0",
                borderRadius: "5px",
                border: "1px dashed #007bff",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              Upload New File
              <input
                type="file"
                name={certName}
                onChange={handleEditFileChange}
                hidden
                key={certName + (selectedFiles[certName]?.name || '')}
              />
            </Button>
            {selectedFiles[certName] && (
              <Typography variant="body2"sx={{ color: "green", mt: 1 }}>
                Selected: {selectedFiles[certName].name}
              </Typography>
            )}

          </Box>
        ))}
      </Box>

      {successMessage && (
        <Typography color="green" align="center" mt={2}>
          {successMessage}
        </Typography>
      )}
      {errorMessage && (
        <Typography color="red" align="center" mt={2}>
          {errorMessage}
        </Typography>
      )}
    </Container>
  );

  // Show Add or Edit based on presence of employee_id param
  return employee_id ? renderEditMode() : renderAddMode();
});

export default AppQualification;
